export const requestAPI = async (url, body, type, requestType) => {
  const reqObj = requestType ? body : JSON.stringify(body);
  let tid =
    process.env.REACT_APP_STAGE === "production"
      ? "f7ebc90c5f8111eca4a1bf874a19b0d0"
      : "3f6b1512465f11ec9bb2a7cb5b6ecc37";
  try {
    const res = await fetch(url, {
      method: type,
      body: type === "POST" ? reqObj : undefined,
      headers: requestType
        ? {
            tenantid: tid,
          }
        : {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            tenantid: tid,
          },
    });
    if (res.status === 401) {
      signOutActions("auth");
    } else {
      const data = await res.json();
      return data;
    }
  } catch (e) {
    return { error: e };
  }
};

export const signOutActions = async (type) => {
  localStorage.clear();
};
